export * from './lib/UiKitLabelBase';
